var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "fastWizardV2" } }, [
    _c(
      "div",
      { staticClass: "Header" },
      [
        _c("Stepper", {
          attrs: { "go-next-page": _vm.activeIndex, steps: _vm.steps },
          on: { changeStep: _vm.stepOnChangeHandler },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wizard-container" },
      [
        _vm.activeIndex === 0
          ? _c("FormStep", {
              on: {
                nextStep: function ($event) {
                  _vm.activeIndex = _vm.activeIndex + 1
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.activeIndex === 1 ? _c("ThemeStep") : _vm._e(),
        _vm._v(" "),
        _vm.activeIndex === 2 ? _c("WorkingHours") : _vm._e(),
        _vm._v(" "),
        _vm.activeIndex === 3 ? _c("Preview") : _vm._e(),
        _vm._v(" "),
        _vm.activeIndex === 4 ? _c("SetupPage") : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [
      _c(
        "div",
        { staticClass: "footer-button-left" },
        [
          _vm.activeIndex !== 0
            ? _c(
                "a-button",
                {
                  staticClass: "next-button",
                  attrs: { type: "primary", ghost: "", size: "large" },
                  on: {
                    click: function ($event) {
                      _vm.activeIndex = _vm.activeIndex - 1
                    },
                  },
                },
                [
                  _c("a-icon", { attrs: { type: "left" } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("fastWizard.previous")) +
                      "\n            "
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-text" },
        [
          _c("SupsisIcon", { staticStyle: { width: "50px", height: "50px" } }),
          _vm._v(" "),
          _c("h4", [_vm._v(_vm._s(_vm.$t("fastWizard.setupSupsisLiveChat")))]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-button-right" },
        [
          _vm.activeIndex !== 4 && _vm.activeIndex !== 0
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", ghost: "", size: "large" },
                  on: {
                    click: function ($event) {
                      _vm.activeIndex = _vm.activeIndex + 1
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("fastWizard.continue")) +
                      "\n                "
                  ),
                  _c("a-icon", { attrs: { type: "right" } }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeIndex === 4
            ? _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    size: "large",
                    disabled: _vm.waiting,
                  },
                  on: { click: _vm.complete },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("fastWizard.completeInitialize")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }